<template>
  <section style="display: flex; flex-direction: row; align-items: center">
    <img @click="goToProfile" class="leftSidePic" :src="addUser.profileImage" />
    <div @click="goToProfile" style="padding-left: 15px">
      <p class="notifTitle">{{ addUser.firstName }} {{ addUser.lastName }}</p>
      <p class="notifText">{{ addUser.year }} -{{ addUser.major }}</p>
    </div>
    <div style="display: flex; flex-direction: row">
      <button @click="rejectRequest" class="requestButton reject"></button>
      <button @click="acceptRequest" class="requestButton accept"></button>
    </div>
  </section>
</template>

<script>
import router from "@/router/index";
import db from "@/db";
import firebase from "@/firebase";
import { mapState, mapActions } from "vuex";

export default {
  props: ["addUser", "requests"],

  components: {},

  data: () => ({}),
  mounted() {
    console.log(this.addUser.id);
  },

  computed: {
    ...mapState("user", ["user"]),
  },

  methods: {
    ...mapActions("user", ["updateUserGroups"]),

    goToProfile() {
      var userName = "";
      if (this.addUser.nameCount) {
        userName =
          this.addUser.firstName +
          "-" +
          this.addUser.lastName +
          "-" +
          this.addUser.nameCount;
      } else {
        userName = this.addUser.firstName + "-" + this.addUser.lastName;
      }
      console.log(userName);
      router.push({ name: "PublicProfile", params: { userName: userName } });
      router.go();
    },
    async acceptRequest() {
      let index = this.requests.findIndex((x) => x.id === this.addUser.id);
      this.requests.splice(index, 1);
      var dmId;
      if (this.user.id > this.addUser.id) {
        dmId = this.user.id + this.addUser.id;
      } else {
        dmId = this.addUser.id + this.user.id;
      }
      var groupDoc = {
        hasSeenLastPost: [],
        recentPosts: [],
        users: [],
      };
      var curUserDoc = {
        profileImage: this.user.profileImage,
        token: this.user.token ? this.user.token : "",
        user_id: this.user.id,
      };
      var otherUserDoc = {
        profileImage: this.addUser.profileImage,
        token: this.addUser.token ? this.addUser.token : "",
        user_id: this.addUser.id,
      };
      const postId = "p" + db.collection("posts").doc().id;
      var post = {
        content: "You can now message each other",
        created_at: Date.now(),
        id: postId,
      };
      groupDoc.users.push(curUserDoc, otherUserDoc);
      groupDoc.recentPosts.push(post);
      delete post.id;
      post.chat_id = dmId;
      var userGroupDoc = {
        name: otherUserDoc.name,
        id: dmId,
        lastVistited: Date.now(),
        notificationsEnabled: true,
      };
      let dmRef = db.collection("directMessages").doc(dmId);
      await dmRef.get().then((doc) => {
        if (doc.exists) {
          dmRef.update({
            users: groupDoc.users,
          });
        } else {
          dmRef.set(groupDoc);
          db.collection("posts")
            .doc(postId)
            .set(post);
        }
      });
      groupDoc.name = otherUserDoc.name;
      groupDoc.profileImage = otherUserDoc.profileImage;
      groupDoc.recentContent = post.content;
      groupDoc.recentTime = "now";
      groupDoc.timeOfLastPost = post.created_at;
      groupDoc.type = "directMessages";
      groupDoc.id = dmId;
      groupDoc.lastVisited = Date.now();
      groupDoc.notificationsEnabled = true;
      this.user.directMessages.push(groupDoc);

      this.$store.commit("messageBoard/setGroupId", groupDoc.id);
      this.$store.commit("messageBoard/setGroupName", groupDoc.name);
      this.$store.commit("messageBoard/setGroupType", groupDoc.type);
      this.$store.commit("messageBoard/setCurGroup", groupDoc);
      this.$store.commit("profile/setInterests", []);
      let linkIndex = this.user.linkRequests.indexOf(this.addUser.id);
      this.user.linkRequests.splice(linkIndex, 1);
      this.user.links = this.user.links ? this.user.links : [];
      this.user.links.push(this.addUser.id);
      this.$store.commit("user/setUser", this.user);
      db.collection("users")
        .doc(this.user.id)
        .update({
          links: firebase.firestore.FieldValue.arrayUnion(this.addUser.id),
          linkRequests: this.requests,
          directMessages: firebase.firestore.FieldValue.arrayUnion(
            userGroupDoc
          ),
        });
      db.collection("users")
        .doc(this.addUser.id)
        .update({
          links: firebase.firestore.FieldValue.arrayUnion(this.user.id),
          directMessages: firebase.firestore.FieldValue.arrayUnion(
            userGroupDoc
          ),
        });
      this.$router.push({
        name: "MessageBoard",
        params: {
          name: groupDoc.name,
          id: groupDoc.id,
          type: groupDoc.type,
        },
      });
      var acceptRequest = firebase
        .functions()
        .httpsCallable("sendAcceptedRequestNotification");
      acceptRequest({
        token: this.addUser.iOSToken ? this.addUser.iOSToken : "",
        name: this.user.firstName + " " + this.user.lastName,
        subtitle: "Accepted your friend request",
      });
    },
    rejectRequest() {
      let index = this.requests.findIndex((x) => x.id === this.addUser.id);
      this.requests.splice(index, 1);
      db.collection("users")
        .doc(this.user.id)
        .update({
          linkRequests: this.requests,
        });
    },
  },
};
</script>

<style scoped>
.requestButton {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin: 3px;
  cursor: pointer;
  border: none;
  background-color: white;
}

.requestButton:hover {
  background-color: #d0d0d0;
}
.notifTitle {
  color: black;
  font-weight: bold;
}
.notifText {
  font-size: 13px;
}
.reject {
  background-image: url("../../assets/linkDeny.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
.accept {
  background-image: url("../../assets/linkAccept.svg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
</style>
